import {useContext, useCallback, useRef} from 'react';
import type L from 'leaflet';
import {ServicesContext} from '@/app/contexts/ServicesContext';

export function useMapBorders() {
	const {backendAPI} = useContext(ServicesContext)!;

	const environmentRef = useRef<{leaflet: typeof L; map: L.Map} | null>();
	const initialize = useCallback((leaflet: typeof L, map: L.Map) => {
		environmentRef.current = {leaflet, map};
	}, []);

	const currentBorderLayer = useRef<L.Layer | null>(null);

	const setBorders = useCallback(async (geoJsonId: string) => {
		const {leaflet, map} = environmentRef.current!;

		// Download the geo json data
		const geoJsonValue = await backendAPI.map.getBoundariesGeoJson(geoJsonId);
		const borderLayer = leaflet.geoJSON(geoJsonValue);
		borderLayer.addTo(map);

		// Remove a previous border layer
		if (currentBorderLayer.current) {
			currentBorderLayer.current.remove();
		}

		currentBorderLayer.current = borderLayer;
	}, []);

	return {initialize, setBorders};
}

useMapBorders.displayName = 'useMapBorders';
